import { render } from "./MarqueeText.vue?vue&type=template&id=ecf629d4"
import script from "./MarqueeText.vue?vue&type=script&lang=js"
export * from "./MarqueeText.vue?vue&type=script&lang=js"

import "./MarqueeText.vue?vue&type=style&index=0&id=ecf629d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__